module.exports = __webpack_public_path__ + "img/key_active.8033cb33.svg";